import { getConstant } from '../utils';

export const getCalculatorsSoilType = getConstant('GET_CALCULATORS_SOIL_TYPE');
export const getCalculatorsSoilTypeItem = getConstant('GET_CALCULATORS_SOIL_TYPE');